
import CreateCustomCertificate from '@/components/ssl/CreateCustomCertificate.vue';
import CreateSelfSignedCertificate from '@/components/ssl/CreateSelfSignedCertificate.vue';
import CreateLetsEncryptCertificate from '@/components/ssl/CreateLetsEncryptCertificate.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { CertificateInterface, CertificatesRepositoryInterface } from '@/services/SSL/interfaces';

@Component({
  inject: ['certificateRepository'],
  components: {
    CreateCustomCertificate,
    CreateSelfSignedCertificate,
    CreateLetsEncryptCertificate,
  },
})
export default class CreateCertificate extends Vue {
  public loading: boolean = true;

  public readonly certificateTypes: string[] = ['LetsEncrypt', 'Custom', 'Self-Signed'];

  public cert: CertificateInterface | undefined;

  public selectedCertificateType: string = '';

  private readonly certificateTypeMap: { [key: string]: string } = {
    letsEncrypt: 'LetsEncrypt',
    custom: 'Custom',
    selfSigned: 'Self-Signed',
  };

  private readonly certificateRepository!: CertificatesRepositoryInterface;

  public get certificate(): CertificateInterface | undefined {
    return this.cert;
  }

  private async created(): Promise<void> {
    const certificateId = this.$route?.query?.id;
    if (!certificateId) {
      this.loading = false;
      return;
    }

    const certificate = await this.certificateRepository.getCertificateById(Number(certificateId));
    this.cert = certificate;
    this.selectedCertificateType = this.certificateTypeMap[certificate.type];

    this.loading = false;
  }

  get certificateForm(): string {
    switch (this.selectedCertificateType) {
      case 'Custom':
        return 'create-custom-certificate';
      case 'Self-Signed':
        return 'create-self-signed-certificate';
      case 'LetsEncrypt':
        return 'create-lets-encrypt-certificate';
    }

    return '';
  }
}
